var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHousingSociety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.996,
    height: 16.994,
    viewBox: "0 0 16.996 16.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9842",
    "data-name": "Group 9842",
    transform: "translate(472.363 -20237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "House",
    d: "M16.876,6.8l-2.6-2.149V1.023a.34.34,0,0,0-.34-.34H11.9a.34.34,0,0,0-.34.34v1.4L8.716.084a.34.34,0,0,0-.428,0L.122,6.8a.34.34,0,0,0-.054.469l1,1.3a.34.34,0,0,0,.483.054l.49-.408v7.935a.864.864,0,0,0,.877.85H14.081a.864.864,0,0,0,.877-.85V8.216l.483.394a.34.34,0,0,0,.218.075H15.7a.34.34,0,0,0,.231-.129l1-1.3A.34.34,0,0,0,16.876,6.8Zm-4.637-5.44H13.6v2.72l-1.36-1.1Zm2.04,14.789a.184.184,0,0,1-.063.126.337.337,0,0,1-.134.044H2.916a.337.337,0,0,1-.134-.044.184.184,0,0,1-.063-.126V7.659L8.5,2.9l5.78,4.76ZM15.6,7.863,8.716,2.226a.34.34,0,0,0-.428,0L1.4,7.87.815,7.108,8.5.785,16.189,7.1Z",
    transform: "translate(-472.36 20236.992)",
    fill: "#0077b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "House-2",
    "data-name": "House",
    d: "M10.538,13.6h2.04a.34.34,0,0,0,.34-.34v-3.4a.34.34,0,0,0-.34-.34h-2.04a.34.34,0,0,0-.34.34v3.4A.34.34,0,0,0,10.538,13.6Zm.34-3.4h1.36v2.72h-1.36Z",
    transform: "translate(-477.783 20236.998)",
    fill: "#db5f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "House-3",
    "data-name": "House",
    d: "M10.538,13.6h2.04a.34.34,0,0,0,.34-.34v-3.4a.34.34,0,0,0-.34-.34h-2.04a.34.34,0,0,0-.34.34v3.4A.34.34,0,0,0,10.538,13.6Zm.34-3.4h1.36v2.72h-1.36Z",
    transform: "translate(-472.783 20236.998)",
    fill: "#db5f28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousingSociety);
export default __webpack_public_path__ + "static/media/housing_society.dc61ba4080b917fe0fbd56609a045f82.svg";
export { ForwardRef as ReactComponent };